export function optionInputValue<V>(value: V, index: number) {
  if (typeof value === 'string') {
    return value;
  }

  return String(index);
}
